import { React, PT, WithData, fetchApi, withRouter } from '@gasbuddy/react';
import { Dimmer, Loader, Table, Segment, Button, TextArea, Form, Message } from 'semantic-ui-react';
import { Auth, Nav } from '../../components';
import { Role } from '../../roles';
import { AddFeature } from './AddFeature';

class BaseFeatures extends React.Component {
  state = {
    column: 'name',
    direction: 'ascending',
  }

  handleSort = clickedColumn => () => {
    const { column, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        direction: 'ascending',
      });
    } else {
      this.setState({
        direction: direction === 'ascending' ? 'descending' : 'ascending',
      });
    }
  }

  deploy = () => {
    this.setState({ pending: true }, async () => {
      await fetchApi({
        url: '/system/features/deploy',
      });
      this.setState({ pending: false });
    });
  }

  importFeature = (e) => {
    e.preventDefault();
    this.setState({ pending: true }, async () => {
      const { import: imp } = this.state;
      const { fetch: fetchFn } = this.props;
      const { body, status } = await fetchApi({
        url: '/system/features/feature/import',
        body: JSON.parse(imp),
      });
      if (status === 200) {
        this.setState({ pending: false, import: null, error: null }, fetchFn);
      } else {
        this.setState({ pending: false, error: body });
      }
    });
  }

  render() {
    const { column, direction, error, import: importValue, pending } = this.state;
    const { data, loading, fetch: fetchFn, onSelected } = this.props;

    const dir = direction === 'ascending' ? 1 : -1;
    const features = data ? data.features.slice().sort((a, b) => {
      switch (column) {
        case 'name':
          return (a.name.localeCompare(b.name)) * dir;
        case 'internal_name':
          return (a.internal_name.localeCompare(b.name)) * dir;
        case 'return_if_before':
          return ((a.return_if_before || 0) - (b.return_if_before || 0)) * dir;
        default:
          return 0;
      }
    }) : [];

    return (
      <Auth forRoles={[Role.Superuser, Role.SystemFeaturesView, Role.SystemFeaturesModify]}>
        <Nav>
          <div>
            <h1>Features</h1>
            <Dimmer.Dimmable as={Segment} dimmed={loading || pending}>
              <Dimmer active={loading || pending}>
                <Loader />
              </Dimmer>
              <Table sortable striped selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell sorted={column === 'internal_name' && direction} onClick={this.handleSort('internal_name')}>Internal Name</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'name' && direction} onClick={this.handleSort('name')}>Name</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'return_if_before' && direction} onClick={this.handleSort('return_if_before')}>Ver</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'record_assignments' && direction} onClick={this.handleSort('record_assignments')}>Recorded</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'record_to_analytics' && direction} onClick={this.handleSort('record_to_analytics')}>Analytics</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {features.map(d => (
                    <Table.Row
                      key={d.internal_name}
                      onClick={() => onSelected(d.feature_id)}
                    >
                      <Table.Cell>{d.internal_name}</Table.Cell>
                      <Table.Cell>{d.name}</Table.Cell>
                      <Table.Cell textAlign="center">{d.return_if_before || '-'}</Table.Cell>
                      <Table.Cell textAlign="center">{d.record_assigments && <span style={{ color: 'green' }} aria-label="check" role="img">&#10004;</span>}</Table.Cell>
                      <Table.Cell textAlign="center">{d.record_to_analytics && <span style={{ color: 'green' }} aria-label="check" role="img">&#10004;</span>}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
                <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan="5">
                      <Button
                        content="Deploy Changes"
                        icon="refresh"
                        labelPosition="left"
                        onClick={this.deploy}
                      />
                      <AddFeature fetch={fetchFn} />
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              </Table>
              <h2>Import Feature</h2>
              {error
                && (
                <Message negative>
                  Import failed.
                  <pre>{JSON.stringify(error, null, '\t')}</pre>
                </Message>
                )
              }
              <Form>
                <TextArea
                  value={importValue || ''}
                  onChange={(e, { value }) => this.setState({ import: value })}
                />
                <Button onClick={this.importFeature}>Import</Button>
              </Form>
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseFeatures.propTypes = {
  data: PT.shape({
    features: PT.arrayOf(PT.shape({
      name: PT.string,
      internal_name: PT.string,
    })),
  }),
  fetch: PT.func.isRequired,
  loading: PT.bool,
  onSelected: PT.func.isRequired,
};

BaseFeatures.defaultProps = { loading: false, data: null };

export const Features = withRouter(({ history }) => (
  <WithData url="/system/features">
    <BaseFeatures
      onSelected={id => history.push(`/system/features/${id}`)}
    />
  </WithData>
));
